// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer-module--container--2dsTv","contact":"Footer-module--contact--27cin","copyright":"Footer-module--copyright--17L1Y"};